export const generateDemoJobs = () => {
  const now = new Date();
  const day = 86400000;

  return [
    {
      id: 'demo_job_1',
      title: 'Hamilton — Frankham Street',
      description: 'Repair water damage and seal roof leaks at the main office building. Bring tar and patching materials.',
      location: 'Accra Central — SE8 4RG — Frankham Street',
      distance: '5 mi',
      scheduledDate: new Date(now.getTime() + 2 * day).toISOString(),
      assignedTo: 'demo_worker_1',
      assignedToName: 'Kwame Mensah',
      status: 'scheduled',
      createdAt: new Date(now.getTime() - 3 * day).toISOString(),
      updatedAt: new Date(now.getTime() - 1 * day).toISOString(),
      companyName: 'Hamilton Ltd',
      companyAddress: '12 Frankham Street, Accra Central',
      clientContact: 'Mr. Frank Hamilton',
      clientEmail: 'frank@hamilton.com',
      clientPhone: '+233 24 123 4567',
      primarySiteContact: 'Kofi Asante',
      siteContactPhone: '+233 24 987 6543',
      jobType: 'Repair',
      jobReference: '162.10500.RL',
      jobDetails: 'Roof leak repair — main office wing. Client reported water ingress after last rains. Inspect, patch, and seal all identified leak points.',
      additionalInfo: 'Access to roof via external ladder. Site opens at 7am.',
      zohoSynced: false,
    },
    {
      id: 'demo_job_2',
      title: 'Tema Port — Dock 4 Electrical',
      description: 'Install new conduit and rewire loading dock lighting. Safety gear required.',
      location: 'Tema Port — Dock 4, Industrial Zone',
      distance: '12 mi',
      scheduledDate: new Date(now.getTime() + day).toISOString(),
      assignedTo: 'demo_worker_1',
      assignedToName: 'Kwame Mensah',
      status: 'scheduled',
      createdAt: new Date(now.getTime() - 4 * day).toISOString(),
      updatedAt: new Date(now.getTime() - 4 * day).toISOString(),
      companyName: 'Tema Port Authority',
      companyAddress: 'Tema Harbour, Industrial Area',
      clientContact: 'Mrs. Abena Danso',
      clientEmail: 'abena@temaport.gh',
      clientPhone: '+233 20 444 5555',
      primarySiteContact: 'Yaw Boateng',
      siteContactPhone: '+233 24 333 7777',
      jobType: 'Installation',
      jobReference: 'TPA-2026-0442',
      jobDetails: 'Full electrical rewire of Dock 4 loading bay. Install new conduit, LED floodlights, and emergency cutoff switch. Must comply with port safety regs.',
      additionalInfo: 'Port security clearance required. Report to Gate B by 6:30am.',
      zohoSynced: true,
    },
    {
      id: 'demo_job_3',
      title: 'Kumasi Mall — Exterior Paint',
      description: 'Power wash and apply weather-resistant paint to north-facing wall.',
      location: 'Kumasi Mall — Ring Road, Adum',
      distance: '3 mi',
      scheduledDate: new Date(now.getTime()).toISOString(),
      assignedTo: 'demo_worker_1',
      assignedToName: 'Kwame Mensah',
      status: 'in-progress',
      createdAt: new Date(now.getTime() - 5 * day).toISOString(),
      updatedAt: new Date(now.getTime() - 0.5 * day).toISOString(),
      companyName: 'Kumasi Shopping Centre Ltd',
      companyAddress: 'Ring Road, Adum, Kumasi',
      clientContact: 'Philip Osei',
      clientEmail: 'philip@kumasi-mall.gh',
      clientPhone: '+233 50 222 8888',
      primarySiteContact: 'Ama Darko',
      siteContactPhone: '+233 24 666 9999',
      jobType: 'Maintenance',
      jobReference: 'KSM-EXT-2026-089',
      jobDetails: 'Exterior wall repaint — north face only. Power wash, patch cracks, apply two coats Dulux Weathershield. Scaffolding provided by client.',
      additionalInfo: '',
      zohoSynced: false,
    },
    {
      id: 'demo_job_4',
      title: 'Takoradi Hotel — HVAC Service',
      description: 'Quarterly AC unit filter replacement and coolant top-up.',
      location: 'Takoradi — Beach Road, Anomabu',
      distance: '8 mi',
      scheduledDate: new Date(now.getTime() + 3 * day).toISOString(),
      assignedTo: '',
      assignedToName: 'Unassigned',
      status: 'scheduled',
      createdAt: new Date(now.getTime() - 6 * day).toISOString(),
      updatedAt: new Date(now.getTime() - 6 * day).toISOString(),
      companyName: 'Seaside Resort Takoradi',
      companyAddress: '45 Beach Road, Anomabu, Takoradi',
      clientContact: 'Isabella Grant',
      clientEmail: 'isabella@seasideresort.gh',
      clientPhone: '+233 24 111 2222',
      primarySiteContact: 'Daniel Mensah',
      siteContactPhone: '+233 20 555 3333',
      jobType: 'Maintenance',
      jobReference: 'SRT-Q2-2026',
      jobDetails: 'Q2 HVAC maintenance for all 12 guest room units + lobby. Replace filters, check coolant levels, test thermostats, clean condenser coils.',
      additionalInfo: 'Poolside units may be wet — bring waterproof boots.',
      zohoSynced: true,
    },
    {
      id: 'demo_job_5',
      title: 'Scott Osborn — Great Sutton Street',
      description: 'Interior plastering and paint touch-ups after office renovation.',
      location: 'London — EC1V 0DF — 50-56 Great Sutton Street',
      distance: '1 mi',
      scheduledDate: new Date(now.getTime() - day).toISOString(),
      assignedTo: 'demo_worker_1',
      assignedToName: 'Kwame Mensah',
      status: 'completed',
      createdAt: new Date(now.getTime() - 7 * day).toISOString(),
      updatedAt: new Date(now.getTime() - 0.8 * day).toISOString(),
      companyName: 'Scott Osborn Properties',
      companyAddress: '50-56 Great Sutton Street, London EC1V 0DF',
      clientContact: 'Scott Osborn',
      clientEmail: 'scott@osbornprops.co.uk',
      clientPhone: '+44 20 7946 0958',
      primarySiteContact: 'James Wilson',
      siteContactPhone: '+44 7700 900123',
      jobType: 'Repair',
      jobReference: '162.10500.RL',
      jobDetails: 'Post-renovation finishing work. Patch plasterboard joints, sand, prime, and paint two coats emulsion to match existing colour (Dulux Egyptian Cotton).',
      additionalInfo: '',
      zohoSynced: false,
    },
    {
      id: 'demo_job_6',
      title: 'City Surface — Airport Road Resurfacing',
      description: 'Full surface treatment and line marking on Airport Road stretch.',
      location: 'Accra — Airport Residential Area — Airport Road',
      distance: '7 mi',
      scheduledDate: new Date(now.getTime() - 2 * day).toISOString(),
      assignedTo: 'demo_worker_1',
      assignedToName: 'Kwame Mensah',
      status: 'completed',
      createdAt: new Date(now.getTime() - 8 * day).toISOString(),
      updatedAt: new Date(now.getTime() - 2 * day).toISOString(),
      companyName: 'City Surface Repairs Ltd',
      companyAddress: 'Airport Road, Accra',
      clientContact: 'Michael Johnson',
      clientEmail: 'michael.johnson@citysurfacerepairs.com',
      clientPhone: '+233 24 000 0000',
      primarySiteContact: 'Solomon Aidoo',
      siteContactPhone: '+233 24 777 8888',
      jobType: 'Installation',
      jobReference: 'CSR-APR-2026-001',
      jobDetails: 'Resurface 800m stretch of Airport Road. Mill existing surface, lay new asphalt binder course, surface course, and thermoplastic line markings.',
      additionalInfo: 'Traffic diversion in place. Coordinate with police detail on site.',
      zohoSynced: true,
    },
    {
      id: 'demo_job_7',
      title: 'Labadi Beach Hotel — Pool Deck Repair',
      description: 'Repair cracked tiles and re-grout pool deck perimeter.',
      location: 'Accra — Labadi Beach Road',
      distance: '4 mi',
      scheduledDate: new Date(now.getTime() - 3 * day).toISOString(),
      assignedTo: 'demo_worker_2',
      assignedToName: 'Ama Darko',
      status: 'completed',
      createdAt: new Date(now.getTime() - 9 * day).toISOString(),
      updatedAt: new Date(now.getTime() - 3 * day).toISOString(),
      companyName: 'Labadi Beach Hotel',
      companyAddress: 'Labadi Beach Road, Accra',
      clientContact: 'Emmanuel Nartey',
      clientEmail: 'emmanuel@labadibeach.gh',
      clientPhone: '+233 24 555 7777',
      primarySiteContact: 'Grace Addo',
      siteContactPhone: '+233 20 999 0000',
      jobType: 'Repair',
      jobReference: 'LBH-PDR-2026-03',
      jobDetails: 'Pool deck tile repair. Remove 14 cracked terracotta tiles, replace with matching stock, re-grout full perimeter, seal joints.',
      additionalInfo: 'Pool closed 6am–2pm for works. Guest access restricted.',
      zohoSynced: false,
    },
  ];
};

export const generateDemoTimesheets = (jobId = null, workerId = null) => [
  {
    id: 'demo_ts_1',
    jobId: jobId || 'demo_job_1',
    workerId: workerId || 'demo_worker_1',
    workerName: 'Kwame Mensah',
    clockIn: new Date(Date.now() - 3600000).toISOString(),
    clockOut: new Date().toISOString(),
    breakMinutes: 15,
    hours: 5.75,
    notes: 'Finished patching two leak spots. Need more sealant tomorrow.',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'demo_ts_2',
    jobId: jobId || 'demo_job_3',
    workerId: workerId || 'demo_worker_1',
    workerName: 'Kwame Mensah',
    clockIn: new Date(Date.now() - 86400000).toISOString(),
    clockOut: new Date(Date.now() - 82800000).toISOString(),
    breakMinutes: 30,
    hours: 3.5,
    notes: 'Paint applied in two coats. Wall looks great.',
    createdAt: new Date(Date.now() - 86400000).toISOString(),
  },
];

export const generateDemoPhotos = (jobId) => [
  {
    id: 'demo_photo_1',
    jobId: jobId || 'demo_job_1',
    url: 'https://via.placeholder.com/300x200?text=Roof+Damage',
    name: 'roof_damage_01.jpg',
    size: 204800,
    uploadedBy: 'demo_worker_1',
    uploaderName: 'Kwame Mensah',
    uploadedAt: new Date().toISOString(),
  },
  {
    id: 'demo_photo_2',
    jobId: jobId || 'demo_job_1',
    url: 'https://via.placeholder.com/300x200?text=After+Patch',
    name: 'roof_after_01.jpg',
    size: 189200,
    uploadedBy: 'demo_worker_1',
    uploaderName: 'Kwame Mensah',
    uploadedAt: new Date().toISOString(),
  },
];

export const generateDemoAuthEvents = () => [
  {
    id: 'demo_ae_1',
    timestamp: new Date(),
    userId: 'demo_worker_1',
    eventType: 'login',
    errorMessage: null,
    deviceInfo: { userAgent: 'Demo Browser', platform: 'web' },
  },
  {
    id: 'demo_ae_2',
    timestamp: new Date(Date.now() - 86400000),
    userId: 'demo_worker_2',
    eventType: 'login_google',
    errorMessage: null,
    deviceInfo: { userAgent: 'Demo Browser', platform: 'web' },
  },
  {
    id: 'demo_ae_3',
    timestamp: new Date(Date.now() - 172800000),
    userId: null,
    eventType: 'login_error',
    errorMessage: 'Invalid password',
    deviceInfo: { userAgent: 'Demo Browser', platform: 'web' },
  },
];